webpackJsonp([182246549230831],{

/***/ 254:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.CommentCount = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _utils = __webpack_require__(141);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var queueResetCount = (0, _utils.debounce)(function () {
	    if (window.DISQUSWIDGETS) window.DISQUSWIDGETS.getCount({ reset: true });
	}, 300, false); // eslint-disable-line no-magic-numbers
	
	var CommentCount = exports.CommentCount = function (_React$Component) {
	    _inherits(CommentCount, _React$Component);
	
	    function CommentCount() {
	        _classCallCheck(this, CommentCount);
	
	        return _possibleConstructorReturn(this, (CommentCount.__proto__ || Object.getPrototypeOf(CommentCount)).apply(this, arguments));
	    }
	
	    _createClass(CommentCount, [{
	        key: 'componentDidMount',
	        value: function componentDidMount() {
	            this.loadInstance();
	        }
	    }, {
	        key: 'shouldComponentUpdate',
	        value: function shouldComponentUpdate(nextProps) {
	            if (this.props.shortname !== nextProps.shortname) return true;
	
	            var nextConfig = nextProps.config;
	            var config = this.props.config;
	            if (nextConfig.url === config.url || nextConfig.identifier === config.identifier) return false;
	            return true;
	        }
	    }, {
	        key: 'componentWillUpdate',
	        value: function componentWillUpdate(nextProps) {
	            if (this.props.shortname !== nextProps.shortname) this.cleanInstance();
	        }
	    }, {
	        key: 'componentDidUpdate',
	        value: function componentDidUpdate() {
	            this.loadInstance();
	        }
	    }, {
	        key: 'loadInstance',
	        value: function loadInstance() {
	            var doc = window.document;
	            if (doc.getElementById('dsq-count-scr')) queueResetCount();else (0, _utils.insertScript)('https://' + this.props.shortname + '.disqus.com/count.js', 'dsq-count-scr', doc.body);
	        }
	    }, {
	        key: 'cleanInstance',
	        value: function cleanInstance() {
	            var body = window.document.body;
	            (0, _utils.removeScript)('dsq-count-scr', body);
	
	            // count.js only reassigns this window object if it's undefined.
	            window.DISQUSWIDGETS = undefined;
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            return _react2.default.createElement(
	                'span',
	                {
	                    className: 'disqus-comment-count',
	                    'data-disqus-identifier': this.props.config.identifier,
	                    'data-disqus-url': this.props.config.url
	                },
	                this.props.children
	            );
	        }
	    }]);
	
	    return CommentCount;
	}(_react2.default.Component);

/***/ }),

/***/ 255:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.CommentEmbed = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var RADIX_BASE = 36;
	
	var CommentEmbed = exports.CommentEmbed = function (_React$Component) {
	    _inherits(CommentEmbed, _React$Component);
	
	    function CommentEmbed() {
	        _classCallCheck(this, CommentEmbed);
	
	        return _possibleConstructorReturn(this, (CommentEmbed.__proto__ || Object.getPrototypeOf(CommentEmbed)).apply(this, arguments));
	    }
	
	    _createClass(CommentEmbed, [{
	        key: 'getSrc',
	        value: function getSrc() {
	            var post = Number(this.props.commentId).toString(RADIX_BASE);
	            var parentParam = this.props.showParentComment ? '1' : '0';
	            var mediaParam = this.props.showMedia ? '1' : '0';
	
	            return 'https://embed.disqus.com/p/' + post + '?p=' + parentParam + '&m=' + mediaParam;
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            return _react2.default.createElement('iframe', {
	                src: this.getSrc(),
	                width: this.props.width,
	                height: this.props.height,
	                seamless: 'seamless',
	                scrolling: 'no',
	                frameBorder: '0'
	            });
	        }
	    }]);
	
	    return CommentEmbed;
	}(_react2.default.Component);
	
	CommentEmbed.defaultProps = {
	    showMedia: true,
	    showParentComment: true,
	    width: 420,
	    height: 320
	};

/***/ }),

/***/ 256:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.DiscussionEmbed = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _utils = __webpack_require__(141);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var DiscussionEmbed = exports.DiscussionEmbed = function (_React$Component) {
	    _inherits(DiscussionEmbed, _React$Component);
	
	    function DiscussionEmbed() {
	        _classCallCheck(this, DiscussionEmbed);
	
	        return _possibleConstructorReturn(this, (DiscussionEmbed.__proto__ || Object.getPrototypeOf(DiscussionEmbed)).apply(this, arguments));
	    }
	
	    _createClass(DiscussionEmbed, [{
	        key: 'componentWillMount',
	        value: function componentWillMount() {
	            if (typeof window !== 'undefined' && window.disqus_shortname && window.disqus_shortname !== this.props.shortname) this.cleanInstance();
	        }
	    }, {
	        key: 'componentDidMount',
	        value: function componentDidMount() {
	            this.loadInstance();
	        }
	    }, {
	        key: 'shouldComponentUpdate',
	        value: function shouldComponentUpdate(nextProps) {
	            if (this.props.shortname !== nextProps.shortname) return true;
	
	            var nextConfig = nextProps.config;
	            var config = this.props.config;
	            if (nextConfig.url === config.url || nextConfig.identifier === config.identifier) return false;
	            return true;
	        }
	    }, {
	        key: 'componentWillUpdate',
	        value: function componentWillUpdate(nextProps) {
	            if (this.props.shortname !== nextProps.shortname) this.cleanInstance();
	        }
	    }, {
	        key: 'componentDidUpdate',
	        value: function componentDidUpdate() {
	            this.loadInstance();
	        }
	    }, {
	        key: 'loadInstance',
	        value: function loadInstance() {
	            var doc = window.document;
	            if (window && window.DISQUS && doc.getElementById('dsq-embed-scr')) {
	                window.DISQUS.reset({
	                    reload: true,
	                    config: this.getDisqusConfig(this.props.config)
	                });
	            } else {
	                window.disqus_config = this.getDisqusConfig(this.props.config);
	                window.disqus_shortname = this.props.shortname;
	                (0, _utils.insertScript)('https://' + this.props.shortname + '.disqus.com/embed.js', 'dsq-embed-scr', doc.body);
	            }
	        }
	    }, {
	        key: 'cleanInstance',
	        value: function cleanInstance() {
	            var doc = window.document;
	            (0, _utils.removeScript)('dsq-embed-scr', doc.body);
	            if (window && window.DISQUS) window.DISQUS.reset({});
	
	            try {
	                delete window.DISQUS;
	            } catch (error) {
	                window.DISQUS = undefined;
	            }
	            var disqusThread = doc.getElementById('disqus_thread');
	            if (disqusThread) {
	                while (disqusThread.hasChildNodes()) {
	                    disqusThread.removeChild(disqusThread.firstChild);
	                }
	            }
	        }
	    }, {
	        key: 'getDisqusConfig',
	        value: function getDisqusConfig(config) {
	            return function () {
	                this.page.identifier = config.identifier;
	                this.page.url = config.url;
	                this.page.title = config.title;
	                this.callbacks.onNewComment = [config.onNewComment];
	            };
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            return _react2.default.createElement('div', { id: 'disqus_thread' });
	        }
	    }]);
	
	    return DiscussionEmbed;
	}(_react2.default.Component);

/***/ }),

/***/ 257:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.DiscussionEmbed = exports.CommentEmbed = exports.CommentCount = undefined;
	
	var _CommentCount = __webpack_require__(254);
	
	var _CommentEmbed = __webpack_require__(255);
	
	var _DiscussionEmbed = __webpack_require__(256);
	
	exports.CommentCount = _CommentCount.CommentCount;
	exports.CommentEmbed = _CommentEmbed.CommentEmbed;
	exports.DiscussionEmbed = _DiscussionEmbed.DiscussionEmbed;
	
	
	var Disqus = {
	    CommentCount: _CommentCount.CommentCount,
	    CommentEmbed: _CommentEmbed.CommentEmbed,
	    DiscussionEmbed: _DiscussionEmbed.DiscussionEmbed
	};
	
	exports.default = Disqus;

/***/ }),

/***/ 141:
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.insertScript = insertScript;
	exports.removeScript = removeScript;
	exports.debounce = debounce;
	function insertScript(src, id, parentElement) {
	    var script = window.document.createElement('script');
	    script.async = true;
	    script.src = src;
	    script.id = id;
	    parentElement.appendChild(script);
	
	    return script;
	}
	
	function removeScript(id, parentElement) {
	    var script = window.document.getElementById(id);
	    if (script) parentElement.removeChild(script);
	}
	
	function debounce(func, wait, runOnFirstCall) {
	    var timeout = void 0;
	    return function () {
	        var context = this; // eslint-disable-line consistent-this
	        var args = arguments;
	
	        var deferredExecution = function deferredExecution() {
	            timeout = null;
	            if (!runOnFirstCall) func.apply(context, args);
	        };
	
	        var callNow = runOnFirstCall && !timeout;
	
	        window.clearTimeout(timeout);
	        timeout = setTimeout(deferredExecution, wait);
	
	        if (callNow) func.apply(context, args);
	    };
	}

/***/ }),

/***/ 265:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),

/***/ 60:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _templateObject = _taggedTemplateLiteralLoose(['\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  color: gray;\n  margin-bottom: 0.6rem;\n  time {\n    font-size: 0.95rem;\n    @media (max-width: 700px) {\n      font-size: 0.8rem;\n    }\n  }\n  span {\n    @media (max-width: 700px) {\n      font-size: 1rem;\n    }\n  }\n'], ['\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  color: gray;\n  margin-bottom: 0.6rem;\n  time {\n    font-size: 0.95rem;\n    @media (max-width: 700px) {\n      font-size: 0.8rem;\n    }\n  }\n  span {\n    @media (max-width: 700px) {\n      font-size: 1rem;\n    }\n  }\n']);
	
	var _styledComponents = __webpack_require__(3);
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _taggedTemplateLiteralLoose(strings, raw) { strings.raw = raw; return strings; }
	
	var TimeDiv = _styledComponents2.default.div(_templateObject);
	
	exports.default = function (_ref) {
	  var date = _ref.date;
	  return _react2.default.createElement(
	    TimeDiv,
	    null,
	    _react2.default.createElement(
	      'span',
	      { className: 'material-icons' },
	      'calendar_today'
	    ),
	    '\xA0',
	    _react2.default.createElement(
	      'time',
	      null,
	      date
	    )
	  );
	};
	
	module.exports = exports['default'];

/***/ }),

/***/ 311:
/***/ (function(module, exports) {

	// empty (null-loader)

/***/ }),

/***/ 176:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.pageQuery = undefined;
	
	var _templateObject = _taggedTemplateLiteralLoose(['\n  margin-top: 2rem;\n  a {\n    color: ', ';\n    text-decoration: underline;\n  }\n'], ['\n  margin-top: 2rem;\n  a {\n    color: ', ';\n    text-decoration: underline;\n  }\n']),
	    _templateObject2 = _taggedTemplateLiteralLoose(['\n  font-size: 2rem;\n  margin-bottom: 1rem;\n'], ['\n  font-size: 2rem;\n  margin-bottom: 1rem;\n']),
	    _templateObject3 = _taggedTemplateLiteralLoose(['\n  margin-bottom: 10rem;\n'], ['\n  margin-bottom: 10rem;\n']);
	
	exports.default = Template;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	__webpack_require__(265);
	
	var _disqusReact = __webpack_require__(257);
	
	__webpack_require__(311);
	
	var _styledComponents = __webpack_require__(3);
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	var _colors = __webpack_require__(12);
	
	var _Date = __webpack_require__(60);
	
	var _Date2 = _interopRequireDefault(_Date);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _taggedTemplateLiteralLoose(strings, raw) { strings.raw = raw; return strings; }
	
	var Section = _styledComponents2.default.section(_templateObject, _colors.siteAccent);
	
	var Title = _styledComponents2.default.h1(_templateObject2);
	
	var ArticleDate = (0, _styledComponents2.default)(_Date2.default)(_templateObject3);
	
	function Template(_ref) {
	  var data = _ref.data;
	
	  // data.markdownRemark holds all our post data and meta data
	  var _data$markdownRemark = data.markdownRemark,
	      frontmatter = _data$markdownRemark.frontmatter,
	      html = _data$markdownRemark.html;
	
	  var disqusShortName = 'leejroberts';
	  var disqusConfig = {
	    identifier: frontmatter.id,
	    title: frontmatter.title
	  };
	
	  return [_react2.default.createElement(
	    'article',
	    null,
	    _react2.default.createElement(
	      Title,
	      null,
	      frontmatter.title
	    ),
	    _react2.default.createElement(ArticleDate, { date: frontmatter.date }),
	    _react2.default.createElement(Section, { dangerouslySetInnerHTML: { __html: html } })
	  ), _react2.default.createElement(_disqusReact.DiscussionEmbed, { shortname: 'leejroberts-com', config: disqusConfig })];
	}
	
	var pageQuery = exports.pageQuery = '** extracted graphql fragment **';

/***/ })

});


// WEBPACK FOOTER //
// component---src-templates-blog-post-template-js-cdc788a8f8f49abb0be2.js